<template lang="pug">
  .authorization
    .authorization__title Восстановление пароля
    .authorization__title--text(v-if="emailStep") Введите адрес электронной почты, на которую зарегистрирован кабинет
    .authorization__title--text(v-if="!emailStep") Введите пароль
    .authorization__form.authorization__form_entry
      form(
        @submit.prevent="onSubmitMethod"
      )
        .auth-form(v-if="emailStep")
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.email }"
            )
              .form-elem__title Email
              .form-elem__body
                input.input.input_full(
                  type="email"
                  v-model="userCredentials.email"
                  placeholder="example@mail.ru"
                  @keyup="keymonitor"
                )
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.recaptcha }"
            )
              .form-elem__body
                .recaptcha
                  .recaptcha__container
                    vue-recaptcha(
                    sitekey='6LdA01UUAAAAAFvkoOYGnd4h7MYWtTiEyYxBBC02'
                    ref='recaptcha'
                    @expired="onExpiredRecapcha"
                    @verify="onVerifyRecapcha"
                    ).recaptcha__elem
              .form-elem__error(
                v-if="userCredentialErrors.recaptcha"
              ) Подтвердите, что вы не робот
        .auth-form(v-if="!emailStep")
          .auth-form__elem
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.password }"
            )
              .form-elem__title Пароль
              .form-elem__body
                input.input.input_full(
                  type="password"
                  v-model="userCredentials.password"
                  @keyup="keymonitor"
                )
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.password2 }"
            )
              .form-elem__title Пароль еще раз
              .form-elem__body
                input.input.input_full(
                  type="password"
                  v-model="userCredentials.password2"
                  @keyup="keymonitor"
                )
        .auth-form__elem.auth-form__elem_button
          .form-elem
            .form-elem__body
              button.button.button_paint-main.button_full(
                :class="{ 'loaded-button': pending }"
                @click="onResetPassword()"
              ) Восстановить
              .form-elem__error(
                v-if="msgError.length > 0"
              ) {{ msgError }}
        .auth-form__elem.auth-form__elem_link
          .form-elem
            .form-elem__body
              <!--.link(-->
                <!--@click="$emit('onChangeModalType', 'sign_up')"-->
              <!--) Регистрация-->
              .link(
                @click="$emit('onChangeModalType', 'sign_in')"
              ) Вход
</template>

<script>
import {mapActions} from "vuex";
import jsMd5 from "js-md5";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "ResetPassword",
  components: {
    VueRecaptcha
  },
  props: {},
  data() {
    return {
      pending: false,
      emailStep: true,
      userCredentials: {
        email: "",
        password: "",
        password2: "",
        recaptcha: ""
      },
      userCredentialErrors: {
        email: false,
        password: false,
        password2: false,
        recaptcha: false
      },
      msgError: "",
      errorMsg: {
        password: "Пароли не совпадают",
        short_password: "Пароль должен содержать минимум 8 символов",
        easy_password: "Пароль слишком простой",
        server:
          "Данный пользователь не существует",
        email: "Неверный формат email"
      }
    };
  },
  computed: {
    reset_password_token() {
      return this.$route.query.reset_password_token;
    }
  },
  methods: {
    ...mapActions(["resetPassword", "changePassword"]),
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    keymonitor() {
      this.userCredentialErrors = {
        email: false,
        password: false,
        password2: false,
        recaptcha: false
      };
      this.msgError = "";
    },
    onResetPassword() {
      this.pending = true;
      const errors = [];

      const minutes = ("0" + new Date().getMinutes()).slice(-2);
      const reverseMinutes = minutes
        .split("")
        .reverse()
        .join("");
      const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);

      if (!this.emailStep) {
        if (
          this.userCredentials.password.length < 8 ||
          this.userCredentials.password2.length < 8
        ) {
          errors.push("password");
          errors.push("password2");
          this.msgError = this.errorMsg.short_password;
        }
        if (this.userCredentials.password2 !== this.userCredentials.password) {
          errors.push("password");
          errors.push("password2");
          this.msgError = this.errorMsg.password;
        }
        if (errors.length > 0) {
          this.pending = false;
          errors.map(el => {
            this.userCredentialErrors[el] = true;
          });
          return;
        }
        this.changePassword({
          params: {
            reset_token: this.reset_password_token
          },
          data: {
            password: this.userCredentials.password,
            xAuthHash
          }
        }).then(response => {
          this.pending = false;
          if (response.status !== 200) {
            if (response.data.password) {
              this.userCredentialErrors.password = true;
              this.userCredentialErrors.password2 = true;
              this.msgError = this.errorMsg.easy_password;
              return;
            }
            return;
          }
          this.$emit("onChangeModalType", "access_msg", {
            title: "Поздравляем",
            text:
              "Вы успешно поменяли пароль, попробуйте войти в учетную запись."
          });
        });
        return;
      }
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.userCredentials.email.length === 0 ||
        !reg.test(this.userCredentials.email)
      ) {
        errors.push("email");
        this.msgError = this.errorMsg.email;
      }
      if (this.userCredentials.recaptcha.length === 0) {
        errors.push("recaptcha");
      }
      if (errors.length > 0) {
        this.pending = false;
        errors.map(el => {
          this.userCredentialErrors[el] = true;
        });
        // this.userCredentialErrors.email = true;
        return;
      }
      this.resetPassword({
        data: {
          email: this.userCredentials.email
        },
        xAuthHash
      }).then(res => {
        this.pending = false;
        if (res.status !== 200) {
          this.userCredentialErrors.email = true;
          this.msgError = this.errorMsg.server;
          return;
        }
        this.$emit("onChangeModalType", "access_msg", {
          title: "Проверьте почту",
          text: `Мы выслали ссылку для восстановления пароля на ${
            this.userCredentials.email
          }`
        });
      });
      // if (this.userCredentials.password.length === 0) {
      //   errors.push("password");
      // }
      // if (this.userCredentials.password2.length === 0) {
      //   errors.push("password2");
      // }
      // if (errors.length > 0) {
      //   errors.map(el => {
      //     this.userCredentialErrors[el] = true;
      //   });
      //   if (
      //     this.userCredentials.password !== this.userCredentials.password2 &&
      //     this.msgError.length === 0
      //   ) {
      //     this.msgError = this.errorMsg.password;
      //   }
      //   return;
      // }
      // if (this.userCredentials.password.length < 8) {
      //   this.msgError = this.errorMsg.short_password;
      //   return;
      // }
      // // const password_reg = /^(?=.*[a-z])(?=.*[A-Z])/;
      // // if (!password_reg.test(this.userCredentials.password)) {
      // //   this.msgError = this.errorMsg.easy_password;
      // //   return;
      // // }
      // const minutes = ("0" + new Date().getMinutes()).slice(-2);
      // const reverseMinutes = minutes
      //   .split("")
      //   .reverse()
      //   .join("");
      // const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);
      // this.reg({
      //   userCredentials: this.userCredentials,
      //   xAuthHash
      // }).then(res => {
      //   if (res.status === 400) {
      //     if (res.data.password) {
      //       this.userCredentialErrors.password = true;
      //       this.userCredentialErrors.password2 = true;
      //       this.msgError = this.errorMsg.easy_password;
      //       return;
      //     }
      //     this.userCredentialErrors.email = true;
      //     this.msgError = this.errorMsg.server;
      //     return;
      //   }
      //   if (res.status === 201) {
      //     this.$emit("onChangeModalType", "access_msg", {
      //       title: "Проверьте почту",
      //       text: `Мы выслали ссылку для подтверждения регистраци на ${
      //         this.userCredentials.email
      //       }`
      //     });
      //   }
      // });
    },
    onSubmitMethod(e) {
      e.preventDefault();
    },
    onVerifyRecapcha(response) {
      this.userCredentials.recaptcha = response;
      this.userCredentialErrors.recaptcha = false;
    },
    onExpiredRecapcha() {
      this.userCredentials.recaptcha = "";
    },
    onResize() {
      const recap = this.$refs.recaptcha.$el;
      const containerWidth = recap.parentElement.offsetWidth;
      const recapWidth = recap.offsetWidth;
      const recapHeight = recap.offsetHeight;
      if (recapWidth > containerWidth) {
        const recapScale = containerWidth / recapWidth;
        recap.style.transform = "scale(" + recapScale + ")";
        recap.parentElement.style.height =
          recap.offsetHeight * recapScale + "px";
      } else {
        recap.style.transform = "scale(1)";
        recap.parentElement.style.height = recapHeight + "px";
      }
    }
  },
  mounted() {
    if (this.reset_password_token) {
      this.emailStep = false;
    }
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>
